import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ProductBlankApp } from './Product.blank.app';
import { createRoot } from 'react-dom/client';
import { SEARCH_PARAM_KEY_DEPTH, SEARCH_PARAM_KEY_LAYOUT, SEARCH_PARAM_KEY_SIZE, SEARCH_PARAM_KEY_TYPE, SEARCH_PARAM_KEY_VARIANT } from './constants/searchParamKeys';
import { ppData } from './configs/ppData.config';
import { getFilteredListOfOptionValues } from './utils/getFilteredListOfOptionValues';
import { ErrorElement } from '../../Components/react/ErrorElement';
const updateUrlState = () => {
    const url = new URL(window.location.href);
    const variantID = url.searchParams.get(SEARCH_PARAM_KEY_VARIANT);
    let updateByVariant = variantID !== null;
    url.searchParams.delete(SEARCH_PARAM_KEY_VARIANT);
    if (variantID !== null) {
        const variantIDNum = +variantID;
        const variant = ppData.variants.find(({ id }) => id === variantIDNum);
        if ((updateByVariant = variant !== undefined)) {
            variant.optionValues.forEach((value, i) => {
                url.searchParams.set(ppData.options[i].searchParamKey, value);
            });
        }
    }
    if (!updateByVariant) {
        const checkAndUpdateParamInURL = (pKey, items) => {
            const urlValue = url.searchParams.get(pKey);
            if (urlValue === null ||
                !items.some(({ value }) => value === urlValue)) {
                url.searchParams.set(pKey, items[0].value);
            }
        };
        ppData.options.forEach(({ name, values }, index) => {
            let spKey = null;
            if (name === 'Type') {
                spKey = SEARCH_PARAM_KEY_TYPE;
            }
            if (name === 'Layout') {
                spKey = SEARCH_PARAM_KEY_LAYOUT;
            }
            if (name === 'Size' && ppData.isOldCustom) {
                spKey = SEARCH_PARAM_KEY_SIZE;
            }
            if (name === 'Depth') {
                spKey = SEARCH_PARAM_KEY_DEPTH;
            }
            spKey !== null && checkAndUpdateParamInURL(spKey, index > 0
                ? getFilteredListOfOptionValues(values, url.searchParams.get(ppData.options[index - 1].searchParamKey))
                : values);
        });
    }
    url.searchParams.sort();
    window.history.replaceState(null, '', url.toString());
};
const container = document.querySelector('#ppApp');
if (container !== null) {
    updateUrlState();
    const appRouter = createBrowserRouter([
        {
            path: '/products/:handle',
            errorElement: React.createElement(ErrorElement, null),
            element: React.createElement(React.Fragment, null,
                React.createElement(ProductBlankApp, null))
        },
        {
            path: '*',
            element: React.createElement(ErrorElement, null)
        }
    ]);
    const root = createRoot(container);
    root.render(React.createElement(RouterProvider, { router: appRouter }));
}
